import { render } from "./ProfileFields.vue?vue&type=template&id=b01bd872"
import script from "./ProfileFields.vue?vue&type=script&lang=js"
export * from "./ProfileFields.vue?vue&type=script&lang=js"

import exportComponent from "/Users/savvy/workspace/innotrail/MentoTestUI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__